import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider
} from '@mui/material/styles'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { createPortal } from 'react-dom'
import AppRouter from './router'
import { getStore, getHistory } from './store'
import { theme } from './theme'
import './App.css'

const dwelletTheme = createTheme(theme) // custom theme here
const toastRoot = document.getElementById('toast-root')

const App = () => {
  return (
    <Provider store={getStore()}>
      {toastRoot && createPortal(<ToastContainer />, toastRoot)}
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={dwelletTheme}>
          <AppRouter history={getHistory()} />
        </ThemeProvider>
      </StyledEngineProvider>
    </Provider>
  )
}

export default App
